import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store.js";
import { derived, writable } from "svelte/store";
import { benchmarksActivityOptions } from "./benchmarks.js";
import { heatmapActivityOptions } from "./heatmap.js";
import { leaderboardActivityOptions } from "./leaderboard.js";
import { liveFeedActivityOptions } from "./liveFeed.js";
import {
  nullStatCardStats,
  statCardGroupUserFilterOptions,
} from "./statCard.js";
import { todoActivityOptions } from "./toDos.js";
import { groups, userIsOnOtherTeam, users } from "./usersAndGroups.js";
import {
  getActivityOption,
  getFromLocalStorage,
  getStickyMultiOptions,
} from "./utils.js";

/* -------- */
/* DEV NOTE */
/* -------- */

// to reset all sticky dashboard settings from local storage, run the following in the chrome console

// Object.keys(localStorage).forEach((key) => {
//   if (key.startsWith("dashboardSettings-")) {
//     localStorage.removeItem(key);
//   }
// })

/* ------- */
/* GENERAL */
/* ------- */

export const isDialogModalOpen = writable(false);

/* --------- */
/* LIVE FEED */
/* --------- */

export const selectedLiveFeedActivityOptions = writable(
  getStickyMultiOptions(
    "selectedLiveFeedActivityOptions",
    liveFeedActivityOptions,
  ),
);

export const refreshLiveFeed = writable(false);
export const liveFeedRefreshButtonState = writable("default");

// TODO - make sticky??
export const selectedLiveFeedTabState = writable("liveFeed");

/* --------- */
/* STAT CARD */
/* --------- */

export const statCardDataLoading = writable(true);
export const statCardData = writable({
  stats: nullStatCardStats,
  selectedDates: { startDate: "", endDate: "" },
});

export const selectedStatCardGroups = writable(
  getStickyMultiOptions("selectedStatCardGroups", [
    ...groups,
    { value: "unassignedUsers", label: "No Group" },
  ]),
);

const statCardUsers = getStickyMultiOptions("selectedStatCardUsers", users);

export const selectedStatCardUsers = writable(statCardUsers);

// TODO - make this a derived store on selectedStatCardUsers
export const selectedStatCardUserIds = writable(
  statCardUsers.map((u) => u.value),
);

export const selectedStatCardUserGroupFilter = writable(
  groups.length
    ? getFromLocalStorage("statCardUserGroupFilter") ||
        statCardGroupUserFilterOptions.find((option) => option.default)
    : {},
);

/* ----------- */
/* LEADERBOARD */
/* ----------- */

export const leaderboardDataLoading = writable(true);
export const leaderboardData = writable({});

export const leaderboardActivityOption = writable(
  getActivityOption(leaderboardActivityOptions, "leaderboard"),
);

export const selectedLeaderboardGroupOptions = writable(
  getStickyMultiOptions("selectedLeaderboardGroupOptions", [
    ...groups,
    { value: "unassignedUsers", label: "No Group" },
  ]),
);

/* ---------- */
/* BENCHMARKS */
/* ---------- */

export const benchmarksData = writable({});
export const benchmarksDataLoading = writable(true);

export const benchmarksActivityOption = writable(
  getActivityOption(benchmarksActivityOptions, "benchmarks"),
);

/* ------------------------ */
/* HEATMAP (EMAIL TRACKING) */
/* ------------------------ */

export const initialHeatmapLoading = writable(true);

export const heatmapData = writable({});
export const selectedHeatmapUser = writable({});
export const heatmapOption = writable(
  getActivityOption(heatmapActivityOptions, "heatmap"),
);

/* ------ */
/* TO-DOS */
/* ------ */

export const filteredToDoActivityOptions = writable([]);
export const selectedToDosActivityOptions = writable(
  getFromLocalStorage("selectedToDosActivityOptions") || todoActivityOptions,
);

export const checkedToDos = writable([]);
export const paginatedToDos = writable([]);

export const toDosRefreshButtonState = writable("default");

export const toDosCampaignOptions = writable([]);
export const selectedToDosCampaignOptions = writable(
  getFromLocalStorage("selectedToDosCampaignOptions") || [],
);
export const selectedToDosDate = writable("");
export const toDosTodayDate = writable("");

export const completedToDoIds = writable([]);

export const preventToDosChecking = derived(
  [userStore, userIsOnOtherTeam],
  ([$userStore, $userIsOnOtherTeam]) =>
    $userIsOnOtherTeam || ($userStore.kind === "viewer" && !$userStore.isAdmin),
);

export const preventToDoAction = derived(
  [checkedToDos, preventToDosChecking],
  ([$checkedToDos, $preventToDosChecking]) =>
    $checkedToDos.length || $preventToDosChecking,
);

/* ------------- */
/* CONTACT PANEL */
/* ------------- */

export const candidate = writable({});

/* ----------------- */
/* DATE RANGE PICKER */
/* ----------------- */

export const dateRangePickerDateTime = writable("");
export const dateRangePickerDispatchEvent = writable(false);
export const dateRangePickerDispatchDestroy = writable(false);
